import { Link } from "react-router-dom";
import { ArrowUpRight, Cog, Layers, Box, Pill, Tablets, Package } from "lucide-react";

const PEEK = [
  { Icon: Layers, label: "Granulation" },
  { Icon: Pill, label: "Capsule Line" },
  { Icon: Tablets, label: "Tablet Press" },
  { Icon: Box, label: "Blending" },
];

export const MachineryTeaser = () => {
  return (
    <section
      id="machinery"
      data-testid="machinery-teaser"
      className="py-24 md:py-32 bg-white border-t border-[#E5E5E5]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7">
          <div className="overline">
            <span className="gold-divider mr-3 align-middle" />
            Inside our facility
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl text-[#1A1A1A] mt-6 leading-tight">
            The machinery
            <br />
            behind the output.
          </h2>
          <p className="text-[#595959] mt-5 leading-relaxed max-w-xl">
            Blenders, capsule filling lines, tablet presses, bottle and powder
            fillers, pouch sealers, induction sealers and more — operated under
            FSSAI, GMP and AYUSH procedures. Take a look at the equipment running
            our floor.
          </p>

          <Link
            to="/machinery"
            data-testid="machinery-teaser-cta"
            className="btn-gold rounded-sm mt-8 inline-flex items-center gap-2 h-12 px-7 text-sm font-semibold tracking-wider"
          >
            View Machinery <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="lg:col-span-5">
          <div className="grid grid-cols-2 gap-3">
            {PEEK.map((p) => {
              const Icon = p.Icon;
              return (
                <div
                  key={p.label}
                  className="aspect-[4/3] bg-gradient-to-br from-[#F7F4EC] via-white to-[#FAFAFA] border border-[#E5E5E5] flex flex-col items-center justify-center gap-3 hover:border-[#D4AF37] transition-colors"
                >
                  <Icon
                    className="w-9 h-9 text-[#D4AF37]/70"
                    strokeWidth={1.2}
                  />
                  <div className="text-xs tracking-[0.18em] uppercase text-[#1A1A1A]">
                    {p.label}
                  </div>
                </div>
              );
            })}
          </div>
          <div className="mt-3 flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-[#8a8a8a]">
            <Cog className="w-3.5 h-3.5" />
            <span>+ 5 more machines on the catalogue</span>
          </div>
        </div>
      </div>
    </section>
  );
};
